export default __webpack_public_path__ + "static/media/bajaj 1.054de1c8.jpg";